export default __webpack_public_path__ + "static/media/Christine.dc63e42e.png";